import { Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import { Suspense, lazy } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import PageLoader from './ui/PageLoader';
import PublicRoutes from './routes/PublicRoutes';
import ClientRoutes from './routes/ClientRoutes';
import ArtisanRoutes from './routes/ArtisanRoutes';
import SharedRoutes from './routes/SharedRoutes';

// MODALS - Lazy Loaded to improve FCP and initial load time
const ProfileModal = lazy(() => import('./features/artisan-public-profile/ProfileModal'));
const AuthUserModal = lazy(() => import('./features/auth/components/AuthUserModal'));
const JoinArtisanModal = lazy(() => import('./features/auth/components/AuthArtisanModal'));
const BookNowModal = lazy(() => import('./modals/BookNowModal'));
const ForgotPasswordModal = lazy(() => import('./features/auth/components/ForgotPasswordModal'));
const CreateProjectModal = lazy(() => import('./features/feed/components/CreateProjectModal'));

import NotFound from './ui/NotFound';

export default function AppRoutes() {
  const location = useLocation();
  const navigate = useNavigate();
  const state = location.state;

  return (
    <Suspense fallback={<PageLoader />}>
      <AnimatePresence mode="wait">
        <motion.div
          key={state?.background?.pathname || location.pathname}
          initial={{ opacity: 0, y: 8 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -8 }}
          transition={{ duration: 0.3, ease: [0.23, 1, 0.32, 1] }}
        >
          <Routes location={state?.background || location}>
            {PublicRoutes()}
            {SharedRoutes()}
            {ClientRoutes()}
            {ArtisanRoutes()}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </motion.div>
      </AnimatePresence>

      {state?.background && (
        <Routes>
          <Route
            path="/artisan/:userId"
            element={<ProfileModal onClose={() => navigate(-1)} />}
          />
          <Route
            path="/signin"
            element={<AuthUserModal mode="signin" />}
          />
          <Route
            path="/signup"
            element={<AuthUserModal mode="signup" />}
          />
          <Route
            path="/forgot-password"
            element={
              <ForgotPasswordModal
                onClose={() => navigate(-1)}
                onBackToLogin={() =>
                  navigate('/signin', {
                    replace: true,
                    state: { background: state?.background || { pathname: '/' } },
                  })
                }
              />
            }
          />
          <Route
            path="/join-artisan"
            element={<JoinArtisanModal />}
          />
          <Route
            path="/book/:userId"
            element={<BookNowModal isBookNowModalOpen={true} onClose={() => navigate(-1)} />}
          />
          <Route
            path="/create-project"
            element={<CreateProjectModal />}
          />
        </Routes>
      )}
    </Suspense>
  );
}
